<template>
    <div>
        <headerComp></headerComp>
    </div>
    <div>
        <section1></section1>
    </div>
    <div>
        <section2></section2>
    </div>
    <div>
        <section3></section3>
    </div>
    <div>
        <footerComp></footerComp>
    </div>
</template>

<script>

import headerComp from '@/components/header.vue';
import footerComp from '@/components/footer.vue';

import section1 from '@/components/framework-section-1.vue';
import section2 from '@/components/framework-section-2.vue';
import section3 from '@/components/framework-section-3.vue';

export default {
    "name": "framework-page",
     components:{
        headerComp,
        footerComp,
        section1,
        section2,
        section3
    },
    setup() {
        
    },
}
</script>

<style lang="scss" scoped>


</style>